import type { Prototype } from "../prototype-types";

export const jessBrownPrototypes: Prototype[] = [
  {
    id: "order-issue-response",
    name: "Order Issue Response",
    path: "/jb/order-issue-response",
    description:
      "Five-variant exploration of how brands respond to retailer issue reports. Variants range from a first-touch cold-start flow to a two-column layout with customer profile sidebar. Includes a scenario switcher for toggling issue types and customer profiles (Baseline, New, Top).",
    owner: "Jess Brown",
    createdAt: "2026-04-22",
    lastUpdated: "2026-05-05",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "/images/thumbnails/order-issue-response.png",
    creationTool: "claude-code",
  },
  {
    id: "report-issues-flow",
    name: "Report Issues Flow",
    path: "/jb/report-issues-flow",
    description: "Proposed changes to the damaged and missing reporting flow.",
    owner: "Jess Brown",
    createdAt: "2026-04-15",
    lastUpdated: "2026-05-16",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "/images/thumbnails/report-issues-flow.png",
    creationTool: "claude-code",
  },
  {
    id: "retailer-payment-balance",
    name: "Retailer Payment Balance",
    path: "/jb/retailer-payment-balance",
    description:
      "Invoice page designed to support a new balance construct, enabling upmarket+ retailers to hold and pay toward a single balance before invoice-level reconciliation.",
    owner: "Jess Brown",
    createdAt: "2026-03-27",
    lastUpdated: "2026-04-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "/images/thumbnails/retailer-payment-balance.png",
    creationTool: "cursor",
  },
  {
    id: "require-creditdebit-in-checkout",
    name: "Require credit/debit in checkout",
    path: "",
    externalUrl: "https://quake-label-90471017.figma.site",
    description:
      "This prototype shows interactions in checkout when a retailer may not check out with bank payment for their order, and must to pick a card to proceed.",
    owner: "Jess",
    createdAt: "2026-02-04",
    lastUpdated: "2026-02-05",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    isExternal: true,
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/988a19416982462fa792060186a63b37d7ddee9a112253b92d50fbeeeed22d10.png",
    creationTool: "figma-make",
  },
  {
    id: "opening-soon-identity-verification",
    name: "Opening Soon Identity Verification",
    path: "/jb/opening-soon-identity-verification",
    description:
      'Identity verification flow for retailers during the "Opening Soon" phase. Soft rejection screen that requests additional documentation to complete account verification.',
    owner: "Jess",
    createdAt: "2025-12-17",
    lastUpdated: "2025-12-19",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "/images/thumbnails/opening-soon-identity-verification.png",
    creationTool: "cursor",
  },
  {
    id: "jb-faire-pay-widget-invoices-page",
    name: "Faire Pay widget on Invoices page",
    path: "/jb/faire-pay-widget-invoices-page",
    description: "To better separate the Faire Pay offering from the rest of Faire, we look to simplify Faire Pay information throughout the rest of the experience.",
    owner: "Jess Brown",
    createdAt: "2026-08-20",
    lastUpdated: "2026-08-20",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/jb-faire-pay-widget-invoices-page.png",
    creationTool: "claude-code",
  },
  {
    id: "jb-faire-pay-credits",
    name: "Faire Pay Credits",
    path: "/jb/faire-pay-credits",
    description:
      "Retailer Settings > Credits page showing brand credits and Faire credits, as the starting point for Faire Pay Rewards variants.",
    owner: "Jess Brown",
    project: "Faire Pay Rewards",
    createdAt: "2026-10-13",
    lastUpdated: "2026-10-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/jb-faire-pay-credits.png",
    creationTool: "claude-code",
  }
];
